import { render, staticRenderFns } from "./editAuthority.vue?vue&type=template&id=24f7e190&lang=pug"
import script from "./editAuthority.vue?vue&type=script&lang=js"
export * from "./editAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports